import {
  DownOutlined,
  FolderOutlined,
  ExclamationOutlined,
} from "@ant-design/icons";
import { Button, MenuProps } from "antd";
import { Dropdown, Space } from "antd";
import { useEffect, useState } from "react";

import "./list-selection-dropdown.css"

type MenuItem = {
  label: string;
  key: string;
  icon: JSX.Element;
};
interface DropdownContainersProps {
  theme: string;
  optionsList: string[];
  onMenuClick: (label: string) => void;
  placeholderText: string;
}

export const DropdownListSelection = ({
  theme,
  optionsList,
  onMenuClick,
  placeholderText,
}: DropdownContainersProps) => {
  const MAX_NAME_LENGHT = 35;

  const [selectedOption, setSelectedOption] = useState<string>(placeholderText);

  const returnContainerName: MenuProps["onClick"] = ({ key }) => {
    onMenuClick(key);
    setSelectedOption(key);
  };

  const handleLenghtyNames = (name: string): string => {
    if (name.length > MAX_NAME_LENGHT) {
      return reduceStringLenght(name);
    } else {
      return name
    }
  }

  const reduceStringLenght = (string: string) => {
    return string.substring(0, MAX_NAME_LENGHT-3)+"..."
  }

  const items: MenuProps["items"] = [];
  if (optionsList.length > 0) {
    for (let i = 0; i < optionsList.length; i++) {
      const item: MenuItem = {
        label: optionsList[i],
        key: optionsList[i],
        icon: <FolderOutlined />,
      };
      items.push(item);
    }
  } else {
    const item: MenuItem = {
      label: "No data avaiable",
      key: "No data avaiable",
      icon: <ExclamationOutlined />,
    };
    items.push(item);
  }

  const menuProps =
    optionsList.length > 0
      ? {
          items,
          onClick: returnContainerName,
        }
      : {
          items,
          onClick: () => console.error("Container list is epmty!"),
        };

  useEffect(() => {
    if (optionsList.length === 1) {
      setSelectedOption(handleLenghtyNames(optionsList[0]));
    }
  }, [optionsList]);

  useEffect(() => {
    setSelectedOption(handleLenghtyNames(placeholderText));
  }, [placeholderText]);

  const textColor = theme === "light" ? "#000000" : "#ffffff";
  const backgoundColor = theme === "light" ? "#ffffff" : "#000000";

  return (
    <Dropdown className="menuProps" menu={menuProps}>
      <Button style={{ color: textColor, backgroundColor: backgoundColor}}>
        <Space>
          {selectedOption}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
